<template>
  <div ref="chartBar" :style="style"></div>
</template>

<script>
  import * as echarts from 'echarts';

  export default {
    props: ['countriesData', 'height', 'studyCountryGoals'],
    data() {
      return {
        data: [],
        targets: [],
        style: '',
        myChart: {},
      };
    },
    created() {
      this.style = `margin:0px; width:100%; max-height:100%; min-height:${this.height}`;
      window.addEventListener('resize', () => {
        if (this.myChart !== null && this.myChart !== undefined) {
          this.myChart.resize();
        }
      });
      this.countriesData.sort((a, b) =>
        a['enrollmentData']['randomized'] > b['enrollmentData']['randomized'] ? 1 : -1,
      );
      this.countriesData.forEach((element, index) => {
        this.data[element['country']] = parseInt(element['enrollmentData']['randomized']);
        let foundGoal = this.studyCountryGoals.find(el => el['country'] === element['country']);
        if (foundGoal !== undefined) {
          this.targets.push(foundGoal['goal']);
        }
      });
    },
    destroyed() {
      this.myChart = null;
    },
    mounted() {
      this.myChart = echarts.init(this.$refs.chartBar);
      let data = ['Randomized'];
      let series = [
        {
          data: Object.values(this.data),
          name: 'Randomized',
          itemStyle: {
            color: '#0095FF',
          },
          type: 'bar',
          label: {
            show: true,
            rotate: 0,
            formatter: '{c}',
            fontSize: 12,
            fontWeight: '700',
            position: 'right',
            lineHeight: 16,
            color: '#0095FF',
          },
          emphasis: {
            disabled: true,
          },
          cursor: 'auto',
        },
      ];
      if (this.targets.length > 0) {
        data.push('Target');
        series.push({
          data: this.targets,
          name: 'Target',
          itemStyle: {
            color: '#C1C7CD',
          },
          type: 'bar',
          label: {
            show: true,
            rotate: 0,
            formatter: '{c}',
            fontSize: 12,
            fontWeight: '700',
            position: 'right',
            lineHeight: 16,
            color: '#C1C7CD',
          },
          emphasis: {
            disabled: true,
          },
          cursor: 'auto',
        });
      }
      let option;
      option = {
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true,
        },
        legend: {
          show: true,
          data: data,
        },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
        },
        yAxis: {
          type: 'category',
          data: Object.keys(this.data),
        },
        series: series,
      };

      option && this.myChart.setOption(option);
    },
  };
</script>

<style></style>
